/*
 * Search for the look (Squary) — product page. Markup and copy: snippets/squary-look.liquid.
 * Experiment pdp-look: B shows the teaser under the options card, C a "Shop de look" button on the first photo
 * (placePhotoButtons). Once the page is idle, B and C ask
 * Squary for this product's look-alikes (POST {api}/api/ai/similar/); with at least 4 the teaser shows, with the
 * 3 closest as round photos. A click opens
 * a <dialog> styled like the shop's "Vergelijk alle opties" popup. Each look-alike is that product's own card from
 * the shop's section overlay-variants-popup (GET /products/<handle>?section_id=overlay-variants-popup), so price,
 * discount label, delivery text and buttons are the shop's; a simple card stands in when the section can't load.
 * Sort and filters (kind, cheaper) are Squary's; "Toon meer" adds the next 12. Each look-alike is shown in its variant
 * with the colour the shopper selected on this page (when it has one). Fails silently.
 * Other blocks open the window with document event squary:look-open {from: the link} (pdp-similar B's "Zie alle"),
 * whatever the pdp-look version.
 */
(function () {
  var dlg = document.querySelector('[data-sq-look]');
  var btn = document.querySelector('[data-sq-look-open]');
  if (!dlg || !btn || typeof dlg.showModal !== 'function' || !window.fetch || !window.DOMParser) return;
  var wrap = btn.parentNode;
  var tpl = document.querySelector('[data-sq-look-photo-tpl]');
  var opener = btn;
  var api = (dlg.getAttribute('data-api') || '').replace(/\/+$/, '');
  var pid = dlg.getAttribute('data-product');
  var lang = dlg.getAttribute('data-lang') || 'en';
  var root = (dlg.getAttribute('data-root') || '/').replace(/\/?$/, '/');
  var body = dlg.querySelector('[data-sq-look-body]');
  var sortSel = dlg.querySelector('[data-sq-look-sort]');
  var allBtn = dlg.querySelector('[data-sq-look-all]');
  var cheapBtn = dlg.querySelector('[data-sq-look-cheaper]');
  var resetBtn = dlg.querySelector('[data-sq-look-reset]');
  var S = {};
  try { S = JSON.parse(dlg.querySelector('[data-sq-look-strings]').textContent); } catch (e) {}
  var state = { kind: 'same', cheaper: false, sort: '' };
  var cache = {}, sections = {};
  var seq = 0;

  // B: the teaser under the options; C: a button on the first product photo (or a ?sq_exp=pdp-look:B / :C preview)
  function version() { return document.documentElement.getAttribute('data-sq-exp-pdp-look') || 'A'; }
  function shown() { return version() === 'C' || (version() === 'B' && getComputedStyle(wrap).display !== 'none'); }

  // C: the button sits on the first photo: desktop, the first picture of the photo grid (the shop reorders it
  // with CSS order when a variant is picked); phone, the first slide of the slider
  function firstPhotos() {
    var out = [];
    var grid = document.querySelector('[data-inner-images]');
    if (grid) {
      var pics = [].slice.call(grid.querySelectorAll(':scope > [data-slide]'));
      pics.sort(function (a, b) { return (+getComputedStyle(a).order || 0) - (+getComputedStyle(b).order || 0); });
      if (pics[0]) out.push(pics[0]);
    }
    var slide = document.querySelector('[data-slider] > [data-slide]');
    if (slide) out.push(slide);
    return out;
  }
  function placePhotoButtons() {
    if (!tpl) return;
    firstPhotos().forEach(function (pic) {
      if (pic.querySelector('.sq-look-photo')) return;
      var b = tpl.content.firstElementChild.cloneNode(true);
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();  // not the shop's zoom or slider
        opener = b; dlg.showModal(); refresh();
      });
      ['pointerdown', 'mousedown', 'touchstart'].forEach(function (t) { b.addEventListener(t, function (e) { e.stopPropagation(); }, { passive: true }); });
      if (getComputedStyle(pic).position === 'static') pic.style.position = 'relative';
      pic.appendChild(b);
    });
    // a picked variant moves another photo to the front: move the button with it
    [].forEach.call(document.querySelectorAll('.sq-look-photo'), function (b) {
      if (firstPhotos().indexOf(b.parentNode) < 0) b.parentNode.removeChild(b);
    });
  }

  // the variant the shopper has selected (the shop keeps it in ?variant=, else the product form's id)
  function selectedVariant() {
    var m = /[?&]variant=(\d+)/.exec(location.search);
    if (m) return m[1];
    var f = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return f ? f.value : '';
  }

  function load(s, offset) {
    var vid = selectedVariant();
    var k = [s.kind, s.cheaper ? 1 : 0, s.sort, offset || 0, vid].join('|');
    if (cache[k]) return cache[k];
    cache[k] = fetch(api + '/api/ai/similar/', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ product_id: pid, variant_id: vid, kind: s.kind, cheaper: s.cheaper ? 1 : 0, sort: s.sort, lang: lang, limit: 12, offset: offset || 0,
        country: (window.Shopify && Shopify.country) || null })
    }).then(function (r) { if (!r.ok) throw new Error('api ' + r.status); return r.json(); })
      .catch(function () { delete cache[k]; return { products: [] }; });
    return cache[k];
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  // at most 4 requests to the shop at a time
  var running = 0, waiting = [];
  function queue(task) {
    return new Promise(function (resolve, reject) {
      waiting.push(function () {
        running++;
        task().then(resolve, reject).then(function () { running--; if (waiting.length) waiting.shift()(); });
      });
      if (running < 4) waiting.shift()();
    });
  }

  function money(eur) {
    var c = window.Shopify && Shopify.currency;
    var cur = (c && c.active) || 'EUR';
    var rate = (c && +c.rate) || 1;
    try { return new Intl.NumberFormat(document.documentElement.lang || lang, { style: 'currency', currency: cur }).format(eur * (cur === 'EUR' ? 1 : rate)); }
    catch (e) { return '€' + Math.round(eur); }
  }

  function productUrl(p) { return root + 'products/' + encodeURIComponent(p.handle) + '?variant=' + p.variant_id; }

  // the product's own card from the shop's compare popup section (cached per product)
  function shopCard(p) {
    if (!sections[p.handle]) {
      var url = root + 'products/' + encodeURIComponent(p.handle) + '?section_id=overlay-variants-popup';
      var get = function () {
        return fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('section ' + r.status); return r.text(); });
      };
      sections[p.handle] = queue(function () {
        return get().catch(function () { return new Promise(function (ok) { setTimeout(ok, 600); }).then(get); });
      })
        .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); })
        .catch(function () { return null; });
    }
    return sections[p.handle].then(function (doc) {
      if (!doc) return null;
      var f = doc.querySelector('form[data-variant][data-id="' + p.variant_id + '"]') || doc.querySelector('form[data-variant]');
      if (!f) return null;
      f = document.importNode(f, true);
      f.removeAttribute('data-component');  // the shop's variant switcher must not take it over
      [].forEach.call(f.querySelectorAll('[data-select-variant-and-toggle]'), function (a) {
        a.removeAttribute('data-select-variant-and-toggle');  // a plain link to the other product
        a.href = productUrl({ handle: p.handle, variant_id: f.getAttribute('data-id') || p.variant_id });
      });
      [].forEach.call(f.querySelectorAll('img[data-src]'), function (img) { img.src = img.getAttribute('data-src'); img.loading = 'lazy'; });
      // the compare popup shows options only (it is one product): add the look-alike's name, drop 'Default Title'
      var info = f.querySelector('.text-body-2.flex-col') || f.querySelector('.mt-2');
      if (info) {
        [].forEach.call(info.querySelectorAll('[index]'), function (row) {
          if (/default tit/i.test(row.textContent)) row.parentNode.removeChild(row);
        });
        var name = el('p', 'order-first');
        if (p.brand) { name.appendChild(el('span', 'text-green-deep-50', p.brand + ' ')); }
        name.appendChild(document.createTextNode(bare(p.title || '', p.brand || '')));
        info.insertBefore(name, info.firstChild);
        // fixed rows (name, option, price, delivery) so every card in a row lines up
        info.classList.add('sq-look-info');
        name.className = 'sq-look-name';
        var opt = info.querySelector('[index]');
        if (!opt) { opt = el('div'); opt.setAttribute('aria-hidden', 'true'); info.insertBefore(opt, name.nextSibling); }
        opt.classList.add('sq-look-opt'); opt.classList.remove('order-first');
        var val = opt.querySelector('.text-green-deep-50');
        if (val) val.title = val.textContent.trim();
        var price = info.querySelector(':scope > div:not([index]):not(.sq-look-opt)');
        if (price) price.classList.add('sq-look-price');
      }
      var chip = f.querySelector(':scope > .bg-beige-medium');
      if (chip) chip.classList.add('sq-look-chip');
      f.classList.add('sq-look-card');
      f.setAttribute('data-sq-look-product', String(p.product_id));
      f.setAttribute('data-sq-look-handle', p.handle);
      // light card: the whole card opens the product; a small cart button on the photo adds it
      var href = productUrl({ handle: p.handle, variant_id: f.getAttribute('data-id') || p.variant_id });
      f.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('a, button')) return;
        location.href = href;
      });
      var label = ((f.querySelector('[data-submit-button] span') || {}).textContent || 'In winkelwagen').trim();
      var quick = el('button', 'sq-look-quick sq-look-add');
      quick.type = 'submit';
      quick.setAttribute('aria-label', label); quick.title = label;
      quick.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 9h16l-1.5 10h-13z"/><path d="M8 9l4-5 4 5"/><path d="M12 12v4M10 14h4"/></svg>';
      f.insertBefore(quick, f.firstChild);
      return f;
    });
  }

  // title without the brand, also when the title spells it differently ('Buster + Punch', 'Wever & Ducre')
  function bare(title, brand) {
    var fold = function (t) { return t.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ''); };
    var b = fold(brand), words = title.split(/\s+/), i;
    if (b) for (i = 1; i <= words.length; i++) {
      var head = fold(words.slice(0, i).join(' '));
      if (head === b) { title = words.slice(i).join(' '); break; }
      if (head.length >= b.length) break;
    }
    return title.replace(/\s+/g, ' ').trim() || title;
  }

  // stand-in when the section can't load: image, name, price
  function simpleCard(p) {
    var a = el('a', 'relative group text-green-deep w-full flex flex-col');
    a.href = productUrl(p);
    a.setAttribute('data-sq-look-product', String(p.product_id));
    var pic = el('div', 'w-full aspect-square bg-white flex items-center justify-center overflow-hidden');
    if (p.image_url) {
      var img = el('img', 'w-full h-full object-cover');
      img.src = p.image_url.replace(/(\.(jpe?g|png|webp))(\?|$)/i, '_400x$1$3'); img.alt = ''; img.loading = 'lazy';
      pic.appendChild(img);
    }
    a.appendChild(pic);
    var t = el('div', 'mt-2 text-body-2 flex flex-col gap-y-1');
    t.appendChild(el('p', null, p.title || ''));
    t.appendChild(el('p', null, p.price ? money(p.price) : ''));
    a.appendChild(t);
    return a;
  }

  function cards(ps) {
    return Promise.all(ps.map(function (p) { return shopCard(p).then(function (c) { return c || simpleCard(p); }); }));
  }

  function moreButton(data, my) {
    var old = body.querySelector('.sq-look__more');
    if (old) old.parentNode.removeChild(old);
    if (!data || !data.more) return;
    var wrapMore = el('div', 'sq-look__more');
    var b = el('button', 'sq-look-more');
    b.type = 'button';
    b.appendChild(el('span', null, (S.more || 'More (__N__)').replace('__N__', data.more)));
    var plus = el('span', null, '+'); plus.setAttribute('aria-hidden', 'true');
    b.appendChild(plus);
    b.addEventListener('click', function () {
      b.disabled = true;
      var next = (data.offset || 0) + ((data.products || []).length);
      load(state, next).then(function (d) {
        return cards((d && d.products) || []).then(function (cs) {
          if (my !== seq) return;
          var grid = body.querySelector('.sq-look-grid');
          cs.forEach(function (c) { grid.appendChild(c); });
          if (cs[0]) { var a = cs[0].querySelector('a') || cs[0]; if (a.focus) a.focus({ preventScroll: true }); cs[0].scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }
          moreButton(d, my);
        });
      });
    });
    wrapMore.appendChild(b);
    body.appendChild(wrapMore);
  }

  // the sort chip is filled when a sort is chosen; "remove all filters" only works when something is set
  function syncControls() {
    sortSel.parentNode.classList.toggle('is-on', !!state.sort);
    resetBtn.disabled = !state.sort && state.kind === 'same' && !state.cheaper;
  }

  function refresh() {
    var my = ++seq;
    syncControls();
    body.textContent = '';
    body.appendChild(el('p', 'sq-look__msg', S.loading || ''));
    load(state, 0).then(function (d) {
      var ps = (d && d.products) || [];
      return cards(ps).then(function (cs) {
        if (my !== seq) return;
        body.textContent = '';
        if (!cs.length) { body.appendChild(el('p', 'sq-look__msg', S.none || '')); return; }
        var grid = el('div', 'sq-look-grid');
        cs.forEach(function (c) { grid.appendChild(c); });
        body.appendChild(grid);
        moreButton(d, my);
      });
    });
  }

  // "In winkelwagen" on a card: add through Shopify (squary.js counts it as add_to_cart), refresh the shop's cart
  // drawer and header count from Shopify's section rendering, then close this dialog and open the drawer.
  function addToCart(form) {
    var id = +form.getAttribute('data-id');
    var b = form.querySelector('.sq-look-quick') || form.querySelector('[data-submit-button]');
    if (!id || (b && b.disabled)) return;
    if (b) { b.disabled = true; b.classList.add('is-active'); }
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
      .then(function (r) {
        if (!r.ok) throw new Error('add ' + r.status);
        var cartUrl = (window.Phill && Phill.routes && Phill.routes.cart) || (root + 'cart');
        return Promise.all([
          fetch(cartUrl + '.js', { credentials: 'include' }).then(function (x) { return x.json(); }),
          fetch(cartUrl + '?sections=cart-drawer', { credentials: 'include' }).then(function (x) { return x.json(); })
        ]);
      })
      .then(function (res) {
        var cart = res[0], secs = res[1];
        dlg.close();
        if (window.app && typeof window.app.emit === 'function') {
          // the shop's own update after an add: re-renders the cart drawer and the header count
          var c = {}; for (var k in cart) c[k] = cart[k]; c.sections = secs;
          window.app.emit(['cart:updated', 'cart:render'], { cart: c });
        }
        var open = document.querySelector('[data-cart-button]');
        if (open) open.click(); else location.href = root + 'cart';
      })
      .catch(function () { location.href = productUrl({ handle: form.getAttribute('data-sq-look-handle'), variant_id: id }); })
      .then(function () { if (b) { b.disabled = false; b.classList.remove('is-active'); } });
  }
  body.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('form[data-variant]');
    if (!f) return;
    e.preventDefault();
    addToCart(f);
  });

  sortSel.addEventListener('change', function () { state.sort = sortSel.value; refresh(); });
  allBtn.addEventListener('click', function () {
    state.kind = state.kind === 'all' ? 'same' : 'all';
    allBtn.setAttribute('aria-pressed', state.kind === 'all' ? 'true' : 'false');
    refresh();
  });
  cheapBtn.addEventListener('click', function () {
    state.cheaper = !state.cheaper;
    cheapBtn.setAttribute('aria-pressed', state.cheaper ? 'true' : 'false');
    refresh();
  });
  resetBtn.addEventListener('click', function () {
    state = { kind: 'same', cheaper: false, sort: '' };
    sortSel.value = ''; allBtn.setAttribute('aria-pressed', 'false'); cheapBtn.setAttribute('aria-pressed', 'false');
    refresh();
  });
  dlg.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-sq-look-close]')) { dlg.close(); return; }
    if (e.target === dlg) dlg.close();  // a click outside the panel
  });
  dlg.addEventListener('close', function () { if (opener && opener.isConnected) opener.focus(); });
  btn.addEventListener('click', function () { opener = btn; dlg.showModal(); refresh(); });
  document.addEventListener('squary:look-open', function (e) {
    if (dlg.open) return;
    opener = (e.detail && e.detail.from) || btn; dlg.showModal(); refresh();
  });

  function start() {
    if (!shown() || !pid || !api) return;
    load(state, 0).then(function (d) {
      var ps = (d && d.products) || [];
      if (ps.length < 4) return;
      if (version() === 'C') {
        placePhotoButtons();
        var grid = document.querySelector('[data-inner-images]');
        if (grid && window.MutationObserver) new MutationObserver(function () { later(placePhotoButtons); })
          .observe(grid, { attributes: true, subtree: true, attributeFilter: ['class'] });
        return;
      }
      // the teaser's round photos: the 3 closest look-alikes
      var pics = btn.querySelector('[data-sq-look-pics]');
      if (pics) ps.filter(function (p) { return p.image_url; }).slice(0, 3).forEach(function (p) {
        var img = el('img');
        img.src = p.image_url.replace(/(\.(jpe?g|png|webp))(\?|$)/i, '_120x$1$3'); img.alt = ''; img.width = 48; img.height = 48;
        pics.appendChild(img);
      });
      btn.hidden = false;
    });
  }
  var later = window.requestIdleCallback || function (f) { return setTimeout(f, 1200); };
  if (document.readyState === 'complete') later(start); else window.addEventListener('load', function () { later(start); });
})();
